import React, { useState } from 'react'
import './whatweoffer.scss'
import { MainHeading, PageHeaderIntro, AltCard, FindAgent, CommonBlueCards, CommonTabs, Breadcrumb, OfferCards } from '../../../components';
import { images } from "../../../utils/customFn";
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
const WhatWeOfferMain = () => {
    const [hrefData, setHrefData] = useState();

    const HeaderData = [
        {
            image: images['people-planting-icon.svg'],
            para: 'You know your business. We know business insurance. In fact, we’ve been providing it to companies like yours for over a century. So when you choose to trust your business with us, you can be confident that we’ll get to know your operations and your employees, so we can help determine what coverages are right for you.',
            para1: 'Let us help protect your company by providing you with a variety of industry-leading business insurance products.',
            para2: 'Are you a national accounts broker or part of a large business looking for loss-sensitive program options? We offer specialized services for national accounts and brokers.',
        },
    ];
    const altCardData = {
        heading: "Business auto",
        image: images['two_people_shaking_hands.avif'],
        content: {
            mainLink: {
                url: "what-we-offer/insurance-products/business-auto-insurance",
                text: "Learn more about business auto insurance >",
            },
            description:
                "If driving is an important part of your business, we’re ready to help you determine the best business auto coverages for your company.",
            links: [
                {
                    url: "/what-we-offer/insurance-products/business-auto-insurance/commercial-auto-insurance",
                    text: "Commercial auto insurance >",
                },
                {
                    url: "/what-we-offer/insurance-products/business-auto-insurance/motor-carrier-insurance",
                    text: "Motor carrier insurance >",
                },
                {
                    url: "/what-we-offer/insurance-products/business-auto-insurance/dealership-auto-coverage",
                    text: "Dealership auto coverage >",
                },
            ],
        },
    };

    const altCardData1 = {
        heading: "Business owner policy",
        image: images['two_people_business_seated_meeting.avif'],
        content: {
            mainLink: {
                url: "/what-we-offer/insurance-products/business-owner-insurance",
                text: "Learn more about business owner insurance >",
            },
            description:
                "You’ve worked hard to get your business to where it is today. We’ll work hard to make sure it’s protected. Let us help you with business owner’s insurance.",
            links: [
                {
                    url: "/what-we-offer/insurance-products/business-owner-insurance/business-liability-insurance",
                    text: "Business liability insurance >",
                },
                {
                    url: "/what-we-offer/insurance-products/business-owner-insurance/property-coverage",
                    text: "Property coverage >",
                },
            ],
        },
    };
    const altCardData2 = {
        heading: "401(k) plans and life insurance",
        image: images['two_people_meeting_over_coffee.avif'],
        content: {
            mainLink: {
                url: "what-we-offer/insurance-products/401k-plans-and-life-insurance",
                text: "Learn more about 401(k) plans and life insurance",
            },
            description:
                "We’re here to help you plan for the future.",
            links: [
                {
                    url: "/what-we-offer/insurance-products/401k-plans-and-life-insurance/401k-plans",
                    text: "401(k) and other retirement plans >",
                },
                {
                    url: "/what-we-offer/insurance-products/401k-plans-and-life-insurance/business-life-insurance",
                    text: "Business life insurance >",
                },
                {
                    url: "what-we-offer/insurance-products/401k-plans-and-life-insurance/individual-life-insurance",
                    text: "Individual life insurance >",
                },
            ],
        },
    };
    const altCardData3 = {
        heading: "Commercial property",
        image: images['forklift_in_warehouse.avif'],
        content: {
            mainLink: {
                url: "/what-we-offer/insurance-products/commercial-property-insurance",
                text: "Learn more about commercial property insurance >",
            },
            description:
                "Choosing the right property insurance provider for your business is key. Let’s work together to develop solutions and identify ways we can help you protect it.",
            links: [
                {
                    url: "/what-we-offer/insurance-products/commercial-property-insurance/building-insurance",
                    text: "Building insurance >",
                },
                {
                    url: "/what-we-offer/insurance-products/shared-insurance-products/business-income-insurance",
                    text: "Business income insurance >",
                },
                {
                    url: "/what-we-offer/insurance-products/shared-insurance-products/business-personal-property-insurance",
                    text: "Business personal property insurance >",
                },
                {
                    url: "/what-we-offer/insurance-products/commercial-property-insurance/crime-insurance",
                    text: "Crime insurance >",
                },
                {
                    url: "/what-we-offer/insurance-products/shared-insurance-products/equipment-breakdown-coverage",
                    text: "Equipment breakdown coverage >",
                },
                {
                    url: "/what-we-offer/insurance-products/commercial-property-insurance/inland-marine-insurance",
                    text: "Inland marine insurance >",
                },
            ],
        },
    };
    const liability = {
        heading: "General liability",
        image: images['two_workers.avif'],
        content: {
            mainLink: {
                url: "/what-we-offer/insurance-products/general-liability-insurance",
                text: "Learn more about general liability insurance >",
            },
            description:
                "Protection against liability claims for your business. Coverage options include product liability, cyber liability, and errors and omissions.",
            links: [
                {
                    url: "/what-we-offer/insurance-products/business-owner-insurance/business-liability-insurance",
                    text: "Business liability insurance >",
                },
                {
                    url: "/what-we-offer/insurance-products/general-liability-insurance/commercial-umbrella-insurance",
                    text: "Commercial umbrella insurance >",
                },
                {
                    url: "/what-we-offer/insurance-products/shared-insurance-products/employment-practices-liability-insurance",
                    text: "Employment practices liability insurance >",
                },
                {
                    url: "/what-we-offer/insurance-products/general-liability-insurance/errors-and-omissions-insurance",
                    text: "Errors and omissions insurance >",
                },
            ],
        },
    };
    const workers = {
        heading: "Workers’ compensation",
        image: images['group_of_employees.avif'],
        content: {
            mainLink: {
                url: "/what-we-offer/insurance-products/workers-compesation",
                text: "Learn more about workers' compensation insurance >",
            },
            description:
                "With our innovative workers’ compensation insurance solutions and experienced claims team, we’ll help you protect your employees and your business.",
            links: [
                {
                    url: "/what-we-offer/insurance-products/workers-compensation/guaranteed-cost-insurance",
                    text: "Guaranteed cost insurance >",
                },
                {
                    url: "/what-we-offer/insurance-products/workers-compensation/retrospective-rating-insurance",
                    text: "Retrospective rating insurance >",
                },
                {
                    url: "/what-we-offer/insurance-products/workers-compensation/small-deductible-plans",
                    text: "Small deductible plans >",
                },
                {
                    url: "/what-we-offer/insurance-products/workers-compensation/large-deductible-plans",
                    text: "Large deductible plans >",
                },
                {
                    url: "/what-we-offer/insurance-products/workers-compensation/self-insured-plans",
                    text: "Self insured plans >",
                },
            ],
        },
    };
    const serviceCard = [
        {
            id: 1,
            imageUrl:
                images["talking-chat-bubbles-card.svg"],
            title: 'Online tools and portals',
            subtitle: 'TOOLS',
            description: '24/7/365 access for you. Manage your business insurance account or your company’s retirement plan online.',
            linkUrl: '',
            linkText: 'Learn more about our online tools and portals',
        },
        {
            id: 2,
            imageUrl:
                images["helping-climb-blue-card.svg"],
            title: 'Claims Services',
            subtitle: 'CLAIMS',
            description:
                'Every company needs insurance protection for when things go wrong. But if you’re like us, you know there’s a bigger picture. We’re here to help you find the right coverage, manage claims, and develop a proactive safety culture to minimize risks.',
            linkUrl: '',
            linkText: 'Learn more about Sentry claims services',
        },
        {
            id: 3,
            imageUrl:
                images["guidance-telescope-card.svg"],
            title: 'Safety services center',
            subtitle: 'SAFETY',
            description: 'Let’s face it. Insurance is not a one-size-fits-all solution. At least not here at Sentry. We get to know you and your business, offering innovative solutions that make sense for you.',
            linkUrl: '',
            linkText: 'Learn more about Safety Services ',
        },
    ];

    const ResourceData = [
        {
            id: 1,
            title: 'Articles and guides',
            description:
                'Explore our resources featuring valuable tools, articles, and guides on topics related to insurance coverages, safety resources, and retirement strategies.',
            linkUrl: '',
            linkText: 'View resources >',
        },
        {
            id: 2,
            title: 'Financial calculators',
            description:
                'Need help planning for retirement? It can be difficult to deal with something that is 10, 20, 30, or even 40 years away. We have a variety of tools and calculators to help you plan for your future.',
            linkUrl: '/',
            linkText: 'View all calculators >',
        },
    ];
    const Selectoptions = [
        { value: 'Constructions', label: 'Constructions' },
        { value: 'DealerShip', label: 'DealerShip' },
        { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
        { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
        { value: 'Service industries', label: 'Service industries' },
        { value: 'Trucking', label: 'Trucking' },
    ];


    const tabsData = [
        {
            id: "Products",
            href: "Products",
            label: "Products",
        },
        {
            id: "Tools",
            href: "Tools",
            label: "Tools and services",
        },
        {
            id: "Resources",
            href: "Resources",
            label: "Resources",
        },
    ];
    const activeTabId = "Products";
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
    ];

    return (
        <div className='what-we-are-main'>
            <Container>
                {/* Breadcrum */}
                <Breadcrumb crumbs={breadcrumbs} />
                {/* heading  */}
                <MainHeading title="Business insurance: What we offer" showshare={false} />

                <CommonTabs tabs={tabsData} activeTab={activeTabId} hrefData={hrefData}
                    setHrefData={setHrefData} />
                {/* page intro */}
                <PageHeaderIntro Data={HeaderData} />
            </Container>
            <div className='alt-card-wrapper' id='Products'>
                <Container>
                    <div className='common-heading'>
                        <h2>Our products</h2>
                        <Link to="/what-we-offer/insurance-products">View all our products {'>'} </Link>
                    </div>
                    <div className='title-heading'>
                        <p>Whether you’re a sole proprietor looking for basic coverages or you need protection for a large company with complex business risks, we have the products to provide a customized policy, just for you.</p>
                    </div>
                    <div className='card-list'>
                        <Row>
                            <Col sm={12} md={6} lg={5} xl={5}>
                                <AltCard
                                    heading={altCardData2.heading}
                                    image={altCardData2.image}
                                    content={altCardData2.content}
                                />
                            </Col>
                            <Col sm={12} md={6} lg={7} xl={7}>
                                <AltCard
                                    heading={altCardData.heading}
                                    image={altCardData.image}
                                    content={altCardData.content}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className='card-list'>
                        <Row>
                            <Col sm={12} md={6} lg={7} xl={7}>
                                <AltCard
                                    heading={altCardData1.heading}
                                    image={altCardData1.image}
                                    content={altCardData1.content}
                                />
                            </Col>
                            <Col sm={12} md={6} lg={5} xl={5}>
                                <AltCard
                                    heading={altCardData3.heading}
                                    image={altCardData3.image}
                                    content={altCardData3.content}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className='card-list'>
                        <Row>
                            <Col sm={12} md={6} lg={5} xl={5}>
                                <AltCard
                                    heading={liability.heading}
                                    image={liability.image}
                                    content={liability.content}
                                />
                            </Col>
                            <Col sm={12} md={6} lg={7} xl={7}>
                                <AltCard
                                    heading={workers.heading}
                                    image={workers.image}
                                    content={workers.content}
                                />
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
            <div className='our_tools' id='Tools'>
                <OfferCards heading="Our tools and services" data={serviceCard}
                    description="Protecting your business doesn’t need to be complicated or time-consuming. That’s why we offer a full range of business insurance services to help make insuring your business organized and efficient—from loss control and safety services to online account management systems."
                />
            </div>
            <Container id='Resources'>
                <CommonBlueCards CardData={ResourceData} Title="Our resources"
                    para="We’ll admit it, business insurance can be confusing at times. We’re here to help make it easier for you to understand policies, prevent claims, and answer questions. We want to help you find the info you’re looking for,
                 so our resources are available to you anytime you need them." />

                <FindAgent options={Selectoptions} />
            </Container>
        </div>
    )
}

export default WhatWeOfferMain;